function markPerformanceAfter(name, customElementConstructor, functionName) {
    const originalFunction = customElementConstructor.prototype[functionName];
    customElementConstructor.prototype[functionName] = function (...args) {
        const returnValue = originalFunction.apply(this, args);
        performance.mark(`${name}-${functionName}-completed`);
        return returnValue;
    };
}
function markPerformanceBefore(name, customElementConstructor, functionName) {
    const originalFunction = customElementConstructor.prototype[functionName];
    customElementConstructor.prototype[functionName] = function (...args) {
        performance.mark(`${name}-${functionName}`);
        return originalFunction.apply(this, args);
    };
}
export function measurePerformance(name, customElementConstructor, measure) {
    markPerformanceBefore(name, customElementConstructor, measure.startFunction);
    markPerformanceAfter(name, customElementConstructor, measure.endFunction);
    const originalEndFunction = customElementConstructor.prototype[measure.endFunction];
    customElementConstructor.prototype[measure.endFunction] = function (...args) {
        const returnValue = originalEndFunction.apply(this, args);
        performance.measure(`${name}-${measure.name}`, `${name}-${measure.startFunction}`, `${name}-${measure.endFunction}-completed`);
        return returnValue;
    };
}
